import i18n from '@assets/i18n';

// translate function of vue-i18n
const { t } = i18n.global;

export default {
    label: t('method.permissions.label'),
    info: t('method.permissions.info'),
    module: 'MethodBuilder',
    permissions: {
        'Read': {
            label: t('method.permissions.readMethod.label'),
            info: t('method.permissions.readMethod.info'),
            availableInRole: true // if true will be visible in role details as a checkbox
        },
    }
};
